import { Oid, ApiPort } from '@ip6m/types';
import { Injectable, Logger } from '@nestjs/common';
import { OidDefinition } from '../interfaces/oid';
import { HuaweiOidDB } from './huawei_oid.service';
import { SnmpService } from './snmp.service';

@Injectable()
export class PortService {
    private ports: ApiPort[] = [];


    constructor(
        private huawei_oidDB: HuaweiOidDB,
        private snmpService: SnmpService) {};


    async getPorts(oltid: any) {
        const portOid:OidDefinition = this.huawei_oidDB.Ports();
        const oids:string[] = this.huawei_oidDB.getChildrenOids(portOid);
        const names:string[] = this.huawei_oidDB.getChildrenNames(portOid);
        const snmpPorts:Oid[] = await this.snmpService.subtree(oltid, oids[0]);
       
        this.ports.length = 0;
        for(let i=0; i<snmpPorts.length; i++) {
            const split = snmpPorts[i].oid.split('.');
            const portId = split.pop();
            const subslotId = split.pop();
            const slotId = split.pop();
            this.ports.push({
                id: portId,
                subslotId: subslotId,
                slotId: slotId,
                oids: []
            });
            const fullOids:string[] = [];
            oids.forEach(oid => {
                fullOids.push(oid + '.' + slotId + '.' + subslotId + '.' + portId );
            });
            try {
                const snmpPortsAllOids = await this.snmpService.get(oltid, fullOids);

                for(let j=0; j<snmpPortsAllOids.length; j++) {
                    snmpPortsAllOids[j].name = names[j];
                    this.ports[i].oids.push(snmpPortsAllOids[j]);
                }   
            } catch (error) {
                Logger.error(error);
            }
        }

        return this.ports;
    }
}